import { Tooltip } from "antd";
import * as React from "react";

type PropsMultipleItemInfo<T> = {
  list: T[] | null | undefined;
  getInfo(item: T): { id: string; name: React.ReactNode };
};

export const MultipleItemInfo = <T,>(
  props: PropsMultipleItemInfo<T>,
): React.ReactNode => {
  const { list, getInfo } = props;
  const first = list?.[0];
  if (!first) return null;
  const label = getInfo(first).name;
  if (list.length < 2) return label;
  const title = (
    <div>
      {list.map(getInfo).map(({ id, name }) => (
        <div key={id}>{name}</div>
      ))}
    </div>
  );
  return (
    <Tooltip title={title}>
      <span>
        {label} (+{list.length - 1})
      </span>
    </Tooltip>
  );
};
